import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getNewsDetails } from "./Services";




export const useGetNewsDetails= (newsId:string) => {
  return useQuery(
    [endpoints.getNewsDetails,newsId],
    () => getNewsDetails(newsId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
